import { render, staticRenderFns } from "./messageDetailModel.vue?vue&type=template&id=6e176463&scoped=true"
import script from "./messageDetailModel.vue?vue&type=script&lang=js"
export * from "./messageDetailModel.vue?vue&type=script&lang=js"
import style0 from "./messageDetailModel.vue?vue&type=style&index=0&id=6e176463&lang=scss"
import style1 from "./messageDetailModel.vue?vue&type=style&index=1&id=6e176463&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e176463",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e176463')) {
      api.createRecord('6e176463', component.options)
    } else {
      api.reload('6e176463', component.options)
    }
    module.hot.accept("./messageDetailModel.vue?vue&type=template&id=6e176463&scoped=true", function () {
      api.rerender('6e176463', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/message/messageDetailModel.vue"
export default component.exports